import { render, staticRenderFns } from "./DashboardProfile.vue?vue&type=template&id=1390867c&scoped=true&"
import script from "./DashboardProfile.vue?vue&type=script&lang=js&"
export * from "./DashboardProfile.vue?vue&type=script&lang=js&"
import style0 from "./DashboardProfile.vue?vue&type=style&index=0&id=1390867c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1390867c",
  null
  
)

export default component.exports